/* hydrus-addon-guard.js  (Alfred, 2026-10-14)
 * Bundle add-ons (product type "ADD ON") are priced for buying WITH a board. If the cart ends up with
 * add-ons but no board (shopper removed the board), swap each add-on for its regular product at the
 * regular price, same quantity. If the regular product is sold out, the add-on is removed.
 * While Fall Deals runs, the free-gift add-ons (Pump Mini, Adjustable Carbon Paddle) are left to
 * hydrus-gift-sync.js, which removes them when their board is gone.
 */
(function () {
  if (window.__hydrusAddonGuard) return; window.__hydrusAddonGuard = true;
  var BOARD_TYPES = ['ISUP', 'SUP', 'Surf'];
  var MAP = {
    'adjustable-carbon-paddle-for-paddleboarding': 'adjustable-carbon-fiber-paddle-tough-blade-performance',
    'shark-3-mini-electric-pump-addon': 'shark-3-mini-electric-pump',
    '12v-electric-paddleboard-pump-li-ion-battery-option-available': 'electric-paddleboard-pump',
    'sand-free-blanket-add-on': 'sand-free-blanket-for-inflatable-paddleboards',
    'add-on-hydrus-deck-cooler-with-waterproof-pocket': 'hydrus-deck-cooler-with-waterproof-pocket-1',
    'add-on-hydrus-20l-dry-backpack': 'hydrus-20l-dry-backpack-1',
    'the-everyday-paddle-add-on': 'the-everyday-paddle'
  };
  var GIFT_END_MS = 1794380399 * 1000;
  var GIFTS = ['shark-3-mini-electric-pump-addon', 'adjustable-carbon-paddle-for-paddleboarding'];
  var busy = false, timer = null;

  async function guard() {
    if (busy) return; busy = true;
    try {
      var cart = await (await fetch('/cart.js', { cache: 'no-store' })).json();
      var hasBoard = cart.items.some(function (it) { return BOARD_TYPES.indexOf(it.product_type) !== -1; });
      if (hasBoard) { busy = false; return; }
      var giftsActive = Date.now() <= GIFT_END_MS;
      var lines = cart.items.filter(function (it) {
        if (it.product_type !== 'ADD ON' && !MAP[it.handle]) return false;
        if (giftsActive && GIFTS.indexOf(it.handle) !== -1) return false;
        return true;
      });
      if (!lines.length) { busy = false; return; }
      var adds = [], updates = {};
      for (var i = 0; i < lines.length; i++) {
        var it = lines[i], std = MAP[it.handle];
        updates[it.key] = 0;
        if (!std) continue;
        try {
          var p = await (await fetch('/products/' + std + '.js')).json();
          var v = (p.variants || []).find(function (x) { return x.available; });
          if (v) adds.push({ id: v.id, quantity: it.quantity });
        } catch (e) {}
      }
      if (adds.length) {
        await fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: adds }) });
      }
      await fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ updates: updates }) });
      document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { source: 'addon-guard' } }));
    } catch (e) { /* never block the cart */ }
    busy = false;
  }

  document.addEventListener('cart:refresh', function (e) {
    var origin = e.detail && e.detail.source;
    if (origin === 'addon-guard') return;
    clearTimeout(timer); timer = setTimeout(guard, 900);
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', guard); else guard();
})();
